import ButtonSimple from './buttons/ButtonSimple';
import ButtonWithVO from './buttons/ButtonWithVO';

export default class OverlayLocation extends Phaser.Group {
  constructor(game) {
    super(game);

    // blurred background
    this.bg = this.game.make.image(0, 0, 'bg_welcome_blur');
    this.addChild(this.bg);

    //
    this.text = this.game.make.text(this.game.defaultWidth / 2, 110, 'Choose where to play', {
      font: '70px Elinor',
      fill: '#FFFFFF',
      stroke: '#000000',
      strokeThickness: 8,
    });
    this.text.anchor.set(0.5, 0);
    this.addChild(this.text);

    const available = Math.min(3, this.game.controller.player.unlockedLocations);
    const allPositions = [
      [{ dx: -165, dy: 35 }, { dx: 165, dy: 35 }],
      [{ dx: -305, dy: 85 }, { dx: 0, dy: 15 }, { dx: 305, dy: 85 }],
    ];
    const names = ['btn_location_summer', 'btn_location_autumn', 'btn_location_winter'];
    const positions = allPositions[available - 2];

    this.buttons = [];
    for (let i = 0; i < available; i++) {
      // button 1 player
      const btn = new ButtonWithVO({
        game: this.game,
        bg: 'btn_location_bg',
        mask: 'btn_location_mask',
        key: names[i],
        dy: -4,
        voId: 'ui_01_elinor_0' + (28 + i),
      });
      btn.x = this.game.defaultWidth / 2 + positions[i].dx;
      btn.y = this.game.defaultHeight / 2 + positions[i].dy;
      btn.data.id = i;
      btn.onInputDown.addOnce(this.handleLocationSelect, this);
      this.addChild(btn);
      this.buttons.push(btn);

      // animations
      btn.scale.set(0);
      this.game.add.tween(btn.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100 * i);
    }

    // back button
    this.btnBack = new ButtonSimple({ game: this.game, up: 'btn_back', over: 'btn_back' });
    this.btnBack.x = (this.game.defaultWidth - this.game.width) * 0.5 + 60;
    this.btnBack.y = 60;
    this.btnBack.onInputDown.addOnce(this.handleBackBtn, this);
    this.addChild(this.btnBack);

    //
    this.onSelect = new Phaser.Signal();
    this.onBack = new Phaser.Signal();

    //
    this.game.scale.onSizeChange.add(this.positionElements, this);
  }

  positionElements() {
    this.btnBack.x = (this.game.defaultWidth - this.game.width) * 0.5 + 60;
  }

  handleLocationSelect(btn) {
    this.selectedButton = btn;
    // lock all buttons
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].inputEnabled = false;
    }
    this.btnBack.inputEnabled = false;

    // zoom the button
    // this.game.add.tween(btn.scale).to({ x: 1.1, y: 1.1 }, 300, Phaser.Easing.Back.Out, true);

    // wait 1 second
    this.game.time.events.add(1000, this.dispatchEvent, this);
  }

  dispatchEvent() {
    this.onSelect.dispatch(this.selectedButton.data.id);
  }

  handleBackBtn() {
    this.onBack.dispatch();
  }

  destroy() {
    this.game.scale.onSizeChange.remove(this.positionElements, this);

    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].destroy();
    }
    this.buttons = null;
    this.btnBack = null;
    this.text = null;
    this.bg = null;
    super.destroy();
  }
}
